angular.module('zc.zenclerkS')
  .component('zcsHeader', {
    templateUrl: '/templates/zenclerk_s/layout/header.html',
    controllerAs: 'vm',
    controller: zcsHeader,
  });

zcsHeader.$inject = [
  '$document',
  '$element',
  '$scope',
  '$state',
  '$stateParams',
  'Agency',
  'Devise',
  'ProjectUser',
  'ZcsLayout',
  'ZcsOemService',
  'ZcsProject',
];

function zcsHeader(
  $document,
  $element,
  $scope,
  $state,
  $stateParams,
  Agency,
  Devise,
  ProjectUser,
  ZcsLayout,
  ZcsOemService,
  ZcsProject,
) {
  const vm = this;

  vm.$onInit = () => {

    // variables
    vm.project = {};
    vm.$stateParams = $stateParams;
    vm.apikey = $stateParams.apikey;
    vm.agencyTitle = '';
    vm.agencyName = '';
    vm.thisMonth = moment().format('YYYY-MM');
    vm.lastMonth = moment().subtract(1, 'month').format('YYYY-MM');
    vm.currentUser = null;
    vm.notification = {
      setting: 0
    };
    vm.state = {
      profile: false,
      profileMenu: false
    };
    // actions
    vm.logout = Devise.signOut;
    // Style & animation
    // ––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––
    // Set class for navigation menu
    vm.isGroup = isGroup;
    vm.isCategory = isCategory;
    vm.toggleProfile = toggleProfile;
    vm.toggleProfileMenu = toggleProfileMenu;
    vm.toggleNotificationsPanel = toggleNotificationsPanel;
    vm.ZcsOemService = ZcsOemService;

    // Project
    // ––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––
    $scope.$on('projectUpdated', (event, project) => updateProject(project));

    $scope.$watch('vm.$stateParams', newval => {
      let apikey = _.get(newval, 'apikey');
      if(apikey) {
        Devise.getCurrentUser()
          .then(currentUser => ZcsProject.get(currentUser.id, newval.apikey))
          .then(newProject => updateProject(newProject));
        vm.apikey = apikey;
      }
    }
      , true);

    // Modal
    // ––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––
    $document.on('keydown', closeProfile);

    // Close the menu when clicking outside it
    $document.on('click', clickHandler);

    // Profile
    // ––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––––
    getProfileInfo();

    // Listen to event which is emitted when user updates the profile
    $scope.$on('userInfoUpdated', getProfileInfo);
  };

  this.$onDestroy = () => {
    $document.off('click', clickHandler);
    $document.off('keydown', closeProfile);
  };

  function calculateTagTasksLeft() {
    vm.tagTasksLeft = 0;
    if(!vm.project.tracking_tag_confirmed_at) {
      vm.tagTasksLeft += 1;
    }
    if(!vm.project.conversion_tag_confirmed_at) {
      vm.tagTasksLeft += 1;
    }
    vm.notification.setting += vm.tagTasksLeft;
  }

  function updateProject(newProject) {
    vm.project = _.merge(vm.project, newProject);

    getAgencyTitle(vm.project);

    calculateTagTasksLeft();

    ProjectUser.all($stateParams.apikey)
      .then(users => {
        vm.projectUsers = users;
        // Build notification
        if(!vm.project.average_conversion_price) {
          vm.notification.setting += 1;
        }
        if(_.get(vm, 'projectUsers.length') === 0) {
          vm.notification.setting += 1;
        }
      });
  }

  function isGroup(group) {
    return _.get($state.current, 'data.group') === group;
  }

  function isCategory(category) {
    return _.get($state.current, 'data.category') === category;
  }

  function toggleProfile() {
    vm.state.profile = !vm.state.profile;
    $('body').toggleClass('modal-open'); // prevent scrolling
    return true;
  }

  // close modal with escape
  function closeProfile(e) {
    if(e.which === 27 && vm.state.profile) {
      vm.toggleProfile();
      $scope.$apply();
    }
  }
  function getProfileInfo() {
    Devise.getCurrentUser().then(currentUser => {
      vm.currentUser = currentUser;
    });
  }

  // Toogle the profile menu
  function toggleProfileMenu() {
    vm.state.profileMenu = !vm.state.profileMenu;
    return true;
  }

  function getAgencyTitle(project) {
    Agency.all()
      .then(agencies => {
        const agency = _.find(agencies, d => d.id === project.agency_id);
        if(agency) {
          vm.agencyTitle = agency.title;
          vm.agencyName = agency.name;
        }
      });
  }

  function clickHandler(e) {
    $scope.$apply(function() {
      if(!$element[0].contains(e.target) && vm.state.profileMenu) {
        vm.state.profileMenu = !vm.state.profileMenu;
      }
    });
  }

  function toggleNotificationsPanel() {
    ZcsLayout.isSidebarVisible = !ZcsLayout.isSidebarVisible;
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/layout/header.js